import config from '@/config';
import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { insertNewMainTask } from '@/shared/utils/infiniteDataHelper';
import { TaskQueryKey } from './queryKey';
export const useCreatePlannedTask = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading, error } = useMutation(values => api.base
        .post(`${config.appUrls.tasks}/api/plannedTasks`, values)
        .then(res => res.data), {
        onSuccess: (data) => {
            queryClient.setQueryData([TaskQueryKey.PlannedTasks], (oldData) => insertNewMainTask(oldData, data));
        },
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
    });
    return {
        createPlannedTask: mutateAsync,
        isLoading,
        error,
    };
};
